/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGrid_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_viewer">;
    readonly " $refType": "PdpRespSimilarItemsGrid_viewer";
};
export type PdpRespSimilarItemsGrid_viewer$data = PdpRespSimilarItemsGrid_viewer;
export type PdpRespSimilarItemsGrid_viewer$key = {
    readonly " $data"?: PdpRespSimilarItemsGrid_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsGrid_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '19f988926e2b264c883ba4e84213252d';
export default node;
